import { render, staticRenderFns } from "./ParamCopy.vue?vue&type=template&id=23c0d2f5&scoped=true"
import script from "./ParamCopy.vue?vue&type=script&lang=js"
export * from "./ParamCopy.vue?vue&type=script&lang=js"
import style0 from "./ParamCopy.vue?vue&type=style&index=0&id=23c0d2f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0d2f5",
  null
  
)

export default component.exports